/* Header: deferred mega-menu images and WhatsApp/Call popup */
(() => {
  const header = document.querySelector('store-header');
  if (!header) return;

  const decodeNavigationImageToken = (imageToken) => {
    const token = imageToken ? imageToken.trim() : '';
    if (!token) return '';

    if (/^(https?:)?\/\//i.test(token)) return token;

    if (/%[0-9A-F]{2}/i.test(token)) {
      try {
        return decodeURIComponent(token);
      } catch (error) {
        return '';
      }
    }

    try {
      return atob(token);
    } catch (error) {
      return '';
    }
  };

  const loadNavigationImages = (container, options = {}) => {
    const scope = container || header;
    scope.querySelectorAll('[data-nav-image-token]').forEach((element) => {
      if (element.dataset.navImageLoaded === 'true') return;
      if (options.excludePanels && element.closest('.disclosure__panel')) return;

      const imageToken = element.dataset.navImageToken;
      if (!imageToken) return;

      const imageSource = decodeNavigationImageToken(imageToken);
      if (!imageSource) return;

      element.style.backgroundImage = `url("${imageSource.replace(/"/g, '\\"')}")`;
      element.dataset.navImageLoaded = 'true';
    });
  };

  const getActiveSidebarPanel = (sidebarMenu) => {
    const activeToggle = sidebarMenu.querySelector('.child-nav__item--toggle.is-visible');
    return activeToggle && activeToggle.closest('details')
      ? activeToggle.closest('details').querySelector(':scope > .disclosure__panel')
      : sidebarMenu.querySelector('.disclosure__panel');
  };

  const getNavigationImageScopes = (target) => {
    const sidebarToggle = target.closest('.mega-nav--sidebar .child-nav__item--toggle');
    if (sidebarToggle) {
      const sidebarDetails = sidebarToggle.closest('details');
      const sidebarPanel = sidebarDetails
        ? sidebarDetails.querySelector(':scope > .disclosure__panel')
        : null;

      return [
        { scope: sidebarToggle },
        { scope: sidebarPanel }
      ].filter((item) => item.scope);
    }

    const sidebarPanel = target.closest('.mega-nav--sidebar .disclosure__panel');
    if (sidebarPanel) return [{ scope: sidebarPanel }];

    const sidebarMenu = target.closest('.mega-nav--sidebar');
    if (sidebarMenu) {
      const leftRail = sidebarMenu.querySelector('.child-nav');
      const activePanel = getActiveSidebarPanel(sidebarMenu);

      return [
        { scope: leftRail, excludePanels: true },
        { scope: activePanel }
      ].filter((item) => item.scope);
    }

    const disclosurePanel = target.closest('.disclosure__panel');
    if (disclosurePanel) return [{ scope: disclosurePanel }];

    const details = target.closest('details');
    if (details) {
      return [{ scope: details.querySelector(':scope > .main-nav__child, :scope > .disclosure__panel') || details }];
    }

    return [{ scope: header }];
  };

  const interactionSelector = '.main-nav__child, .child-nav__item--toggle, .grandchild-nav__item, .promo';
  const loadFromInteraction = (event) => {
    const eventTarget = event.target;
    if (!eventTarget || typeof eventTarget.closest !== 'function') return;

    const interactionTarget = eventTarget.closest(interactionSelector);
    if (!interactionTarget || !header.contains(interactionTarget)) return;

    getNavigationImageScopes(eventTarget).forEach((item) => {
      loadNavigationImages(item.scope, { excludePanels: item.excludePanels });
    });
  };

  header.addEventListener('pointerover', loadFromInteraction, { passive: true });
  header.addEventListener('touchstart', loadFromInteraction, { passive: true });
  header.addEventListener('click', loadFromInteraction);
  header.addEventListener('focusin', loadFromInteraction);

  header.querySelectorAll('.secondary-nav__contact-menu').forEach((menu) => {
    const toggle = menu.querySelector('.secondary-nav__contact-toggle');
    const headerSection = header.closest('.shopify-section-group-header-group');
    if (!toggle) return;

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const isOpen = menu.classList.toggle('is-open');
      if (headerSection) headerSection.classList.toggle('secondary-nav-contact-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    document.addEventListener('click', (event) => {
      if (menu.contains(event.target)) return;
      menu.classList.remove('is-open');
      if (headerSection) headerSection.classList.remove('secondary-nav-contact-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  });

})();

/**
 * Currency (country) picker with flags for the header.
 */
if (!customElements.get('header-currency')) {
  class HeaderCurrency extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('.mps-loc-cur__button');
      this.panel = this.querySelector('.mps-loc-panel');
      this.search = this.querySelector('.mps-loc-panel__search');
      this.items = Array.from(this.querySelectorAll('.mps-loc-panel__item'));
      this.empty = this.querySelector('.mps-loc-panel__empty');
      this.divider = this.querySelector('.mps-loc-panel__divider');

      this.handleOutside = this.handleOutside.bind(this);
      this.handleKey = this.handleKey.bind(this);

      this.button.addEventListener('click', () => this.toggle());
      this.search.addEventListener('input', () => this.filter());
      this.items.forEach((item) => {
        item.addEventListener('click', () => this.select(item.dataset.country));
      });
    }

    toggle(force) {
      const open = typeof force === 'boolean' ? force : this.panel.hidden;
      this.panel.hidden = !open;
      this.button.setAttribute('aria-expanded', open);

      if (open) {
        document.addEventListener('click', this.handleOutside);
        document.addEventListener('keydown', this.handleKey);
        if (window.matchMedia('(min-width: 769px)').matches) this.search.focus();
        const current = this.panel.querySelector('[aria-current]');
        if (current) current.scrollIntoView({ block: 'nearest' });
      } else {
        document.removeEventListener('click', this.handleOutside);
        document.removeEventListener('keydown', this.handleKey);
      }
    }

    handleOutside(evt) {
      if (!this.contains(evt.target)) this.toggle(false);
    }

    handleKey(evt) {
      if (evt.key === 'Escape') {
        this.toggle(false);
        this.button.focus();
      }
    }

    filter() {
      const term = this.search.value.trim().toLowerCase();
      let visible = 0;
      this.items.forEach((item) => {
        const match = !term || item.dataset.search.includes(term);
        item.parentElement.hidden = !match;
        if (match) visible += 1;
      });
      if (this.divider) this.divider.hidden = Boolean(term);
      this.empty.hidden = visible > 0;
    }

    select(code) {
      this.form.querySelector('input[name="country_code"]').value = code;
      this.form.submit();
    }
  }

  customElements.define('header-currency', HeaderCurrency);
}
